import { required, email } from 'vuelidate/lib/validators'

export default {
  address: {
    name: {
      required
    },
    zip: {
      required
    },
    street: {
      required
    },
    number: {
      required
    },
    district: {
      required
    },
    city: {
      required
    },
    state: {
      required
    },
    email: {
      required,
      email
    },
    parking: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/addresses/form/resources/validations.js